module.exports = __webpack_public_path__ + "ionicons.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/ionicons/fonts/ionicons.ttf?v=2.0.1
// module id = 1517
// module chunks = 14